import React from 'react';

import { ClearVerifyStaffTableClearVerifyAdmin } from 'src/components/clearVerifyStaff';

export const ClearVerifyStaffPageClearVerifyAdmin: React.FC = () => {
  return <ClearVerifyStaffTableClearVerifyAdmin />;
};
